import * as React from "react";
import type { SVGProps } from "react";
const SvgReports = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24" {...props}
  >
    <path
      stroke="#D6DBE7"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M5.998 11H12M5.998 7.998h3"
    />
    <path
      stroke="#D6DBE7"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M7.498 17.002c-.829 0-1.5-.672-1.5-1.5v0c0-.829.671-1.5 1.5-1.501v0c.829 0 1.5.672 1.5 1.5v0c0 .83-.671 1.5-1.5 1.501M12.5 17.252h2.501v3.752h-2.5a.5.5 0 0 1-.501-.5v-2.751a.5.5 0 0 1 .5-.5M15.502 13h2a.5.5 0 0 1 .5.5v7.504h-3V13.5a.5.5 0 0 1 .5-.5M18.503 15.252h2a.5.5 0 0 1 .5.5v4.752a.5.5 0 0 1-.5.5h-2.5v-5.252a.5.5 0 0 1 .5-.5"
      clipRule="evenodd"
    />
    <path
      stroke="#D6DBE7"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M8.999 21.004H4.997a2 2 0 0 1-2-2V4.996a2 2 0 0 1 2-2h8.175c.53 0 1.04.21 1.415.586l2.83 2.83c.375.374.585.883.585 1.414v2.172"
    />
  </svg>
);
export default SvgReports;
